<template>
    <div>

        <span v-if="loading"><i class="far fa-circle-notch fa-spin"></i> Récupération des données en cours</span>
        <span v-if="!loading && chart.datasets.length == 0" class="ix-text-secondary ix-text-small">Graphique indisponible</span>
        <div v-if="chart.datasets.length > 0 && !loading">
            <custom-chart type="bar" :datasets="chart.datasets" :labels="chart.labels" :options="chart.options" ref="myChartRef"></custom-chart>
        </div>
    </div>
</template>


<script>
import CustomChart from '../CustomChart.vue';

export default {
    props: ["setupRoute"],
    components : {
        CustomChart,
    },
    data() {
        return {
            chart: {
                    datasets: [],
                    options: {
                        plugins: {
                            legend: {
                                display: false,
                            },
                            tooltip : {
                                callbacks: {
                                    label: function(context){
                                        let label = [context.dataset.label + ': ' + context.parsed.y];

                                        if(['prediction'].includes(context.dataset.labelType)){
                                            const dateLabel = context.label;
                                            const chart = context.chart;
                                           
                                            const expenseDataset = chart.data.datasets.find(ds => ds.labelType === 'purchaseTooltips');
                                            const bookingDataset = chart.data.datasets.find(ds => ds.labelType === 'bookingTooltips');

                                            if (expenseDataset && expenseDataset.data && expenseDataset.data[dateLabel]) {
                                                expenseDataset.data[dateLabel].forEach((expense) => {
                                                    label.push(expense)
                                                })
                                            }
                                            
                                            if (bookingDataset && bookingDataset.data && bookingDataset.data[dateLabel]) {
                                                bookingDataset.data[dateLabel].forEach((booking) => {
                                                    label.push(booking)
                                                })
                                            }
                                        }

                                        return label;
                                    }
                                } 
                            }
                        },
                        onClick: (event, elements) => {
                            
                        },
                        responsive: true,
                        maintainAspectRatio: false,
                        scales: { 
                            x: {
                                stacked: false,
                                grid: {
                                    display: false // Masque la grille X
                                },
                                offset: false
                            }, 
                            y: 
                            { 
                                stacked: false,
                                grid: {
                                    display: false // Masque la grille X
                                }
                             } 
                        }
                    },
                    labels: [],
            },
            loading: false,
        }
    },
    methods: {
        getData: async function() {
            this.loading = true;
            fetch(this.setupRoute, {
                ...{
                    method: 'GET'
                },
                ...this.getHttpJsonRequestHeaders()
            }).then((response) => {
                return response.json();
            }).then((data) => {
                if (data.datasets.length > 0 && data.labels.length > 0) {
                        data.datasets.forEach(dataset => {
                            this.chart.datasets.push(dataset)
                        })
                        this.chart.labels = data.labels
                }


                if (data.low_level !== undefined && data.low_level !== null) {
                    this.chart.options.plugins.annotation.annotations.seuilBas = {
                        type: 'line',
                        yMin: data.low_level,
                        yMax: data.low_level,
                        borderColor: 'red',
                        borderWidth: 2,
                        borderDash: [6, 6],
                        label: {
                            display: true,
                            content: 'Seuil bas',
                            color: 'red',
                            position: 'end',
                            backgroundColor: 'transparent',
                            yAdjust: +10,
                        }
                    };
                }
                if (data.high_level !== undefined && data.high_level !== null) {
                    this.chart.options.plugins.annotation.annotations.seuilHaut = {
                        type: 'line',
                        yMin: data.high_level,
                        yMax: data.high_level,
                        borderColor: 'green',
                        borderWidth: 2,
                        borderDash: [6, 6],
                        label: {
                            display: true,
                            content: 'Seuil haut',
                            color: 'green',
                            position: 'end',
                            backgroundColor: 'transparent',
                            yAdjust: -10,
                        }
                    };
                }


               
                this.$nextTick(() => {
                    if (this.$refs.myChartRef) {
                        this.$refs.myChartRef.updateChart();
                    }
                });
                this.loading = false;
            }).catch(error => {
                    console.log(error)
            });
        }
    },
    mounted() {
        this.chart.options.plugins = this.chart.options.plugins || {};
        this.chart.options.plugins.annotation = this.chart.options.plugins.annotation || {};
        this.chart.options.plugins.annotation.annotations = this.chart.options.plugins.annotation.annotations || {};
       // this.chart.options.plugins.tooltip = this.chart.options.plugins.tooltip || {}
        this.getData();

      
    }
}

</script>

<style>
.custom-chart {
    width: 100% !important;
    height: 100% !important;
    min-height: 350px !important; /* ou la hauteur que tu veux */
    max-height: 100% !important;
    position: relative;
  }
</style>